export default ($axios) => ({
  fetchTags(query) {
    return $axios.get('/omni/tags', { params: query }).then((response) => response.data);
  },
});
